import BlogPostCard from './BlogPostCard';

interface BlogListProps {
  posts: any[];
}

export default function BlogList({ posts }: BlogListProps) {
  if (posts.length === 0) {
    return (
      <div className="bg-white rounded-2xl border border-[#E8E2D6] p-12 text-center">
        <i className="ri-article-line text-6xl text-gray-300 mb-4 block"></i>
        <h3 className="font-['Oswald'] text-2xl font-bold text-[#1C2B1E] mb-2">No articles found</h3>
        <p className="text-gray-700">Try adjusting your search or filter to see more results.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {posts.map((post, idx) => (
        <BlogPostCard key={post.id} post={post} priority={idx === 0} />
      ))}
    </div>
  );
}
